import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  BannedIpInterface,
  setEditId,
  setEditError,
  selectBannedIpById
} from "src/store/mine_craft/bannedIpsSlice";
import {
  updateBannedIp,
  fetchBannedIp
} from "src/actions/mine_craft/bannedIpsActions";

import DrawerRight from "src/componets/DrawerRight";
import FormEdit from './_partials/_FormEdit';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.mineCraft.bannedIps.editId);
  const error   = useAppSelector(state => state.mineCraft.bannedIps.editError);
  const bannedIp = useAppSelector(state => selectBannedIpById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchBannedIp(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: BannedIpInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: BannedIpInterface) {
    const resultAction = await dispatch(updateBannedIp({ id, data }));

    if (updateBannedIp.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-banned-ip'>
        <h6 className="v-content-label">Edit Banned IP</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <FormEdit params={bannedIp} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
